<template>
    <div class="expenses-card mb-3">
        <edit-expense-modal @expense-updated="$emit('expense-updated')" :expense="expense"></edit-expense-modal>
        <div class="d-flex align-items-center inner">
            <div class="flex-grow-1">
                <b v-b-tooltip.hover :title="contactTooltip" class="expense-name">{{ expense.description }}</b>
                <div class="mb-1 expense-amount" v-if="expense">
                    {{ formatCurrency(expense.amount, expense.currency) }}
                </div>
            </div>
            <div class="flex-shrink-1">
                <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 mt-2">
                    <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>
                    <b-dropdown-item @click="edit">Edit</b-dropdown-item>
                    <b-dropdown-item @click="requestDelete" variant="danger">Delete
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EditExpenseModal from './EditExpenseModal.vue';
export default {
    name: 'Expense',
    props: ['expense'],

    data() {
        return {
            isDeleting: false
        }
    },

    components: { EditExpenseModal },

    methods: {
        formatCurrency(amount, currency) {
            // Format the price above to USD using the locale, style, and currency.
            let formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currency,
            });
            return formatter.format(amount / 100);
        },

        edit() {
            this.$bvModal.show('edit-expense-' + this.expense.id + '-modal');
        },

        requestDelete() {
            let vm = this;
            swal({
                title: "Are you sure you want to delete this expense?",
                icon: "warning",
                buttons: {
                    cancel: true,
                    confirm: "Delete"
                },
                dangerMode: true,
            }).then((shouldRemove) => {
                if (shouldRemove) {
                    vm.delete();
                }
            });
        },

        delete() {
            let vm = this;
            vm.isDeleting = true;
            axios.delete(API_BASE + '/tickets/' + this.expense.ticket_id + '/expenses/' + vm.expense.id).then(r => {
                vm.isDeleting = false;
                vm.$emit('expense-deleted');
                this.$notify.success({
                    title: 'Success!',
                    message: 'Expense deleted successfully'
                });
            }).catch(e => {
                vm.isDeleting = false;
                vm.notifyErrors(e);
            });
        }
    }
}
</script>

<style scoped lang="scss">
.expenses-card {
    background: #fff;
    border-radius: 5px;

    padding-top: 12px;
    padding-bottom: 12px;

    .expense-name {
        font-weight: 600;
        color: #2c5cc5;
        margin-bottom: 10px;
        display: block;
    }

    .expense-amount {
        font-size: 12px;
        margin-bottom: 0 !important;
    }

    .inner {
        padding-left: 15px;
        padding-right: 15px;
    }

    .inner-bottom {
        padding-top: 0;
        // padding-bottom: 12px !important;
        font-size: 12px;
    }
}
</style>